module.exports = __webpack_public_path__ + "img/bounce.8f031d62.png";